var render = function render(_c,_vm){return _c('td',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.props.track.title))]}),(_vm.props.track.description)?_c('div',{staticClass:"text-muted"},[_c('small',[_vm._v(_vm._s(_vm.props.track.description))])]):(_vm.props.track.artist)?_c('div',{staticClass:"d-lg-none text-muted"},[_c('small',[_vm._v(_vm._s(_vm.props.track.artist))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }